import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import ReactStars from "react-stars";
import Enums from "../../assets/JsonData/Enums";
import { convertDateToLocalTime, truncate } from "../../assets/utils/UtilsFunctons";
import DigDayDurationAndLocation from "./DigDayDurationAndLocation";
import useConfirm from "../FormConFirmDialog/UseFormConfirmDialog";

const DigDayInfosCard = ({ digDay, fullSize, onFocus, isClickable, isDetachable = false, handleOnDetach }) => {
  const [isClicked, setIsClicked] = useState(false);
  const { isConfirmed } = useConfirm();

  const ConfirmMessage = useCallback(() => {
    return (
      <div className="d-flex flex-column">
        <span>Souhaitez-vous détacher ce digDay ?</span>
        <strong>{truncate(digDay.title, 55)}</strong>
      </div>
    );
  }, []);

  const handleOnDetachClick = useCallback(async () => {
    const confirmed = await isConfirmed(ConfirmMessage());
    if (confirmed) {
      handleOnDetach(digDay?.digDayId);
    }
    setIsClicked(false);
  }, [digDay]);

  return digDay ? (
    <div
      className="list-group-item rounded-3 py-3"
      style={{
        maxWidth: fullSize ? "500px" : "352px",
        minWidth: "300px",
        maxHeight: fullSize ? "100%" : "200px",
        border: `${onFocus || isClicked ? "2px" : "1px"} solid ${onFocus || isClicked ? "#2f528f" : "grey"}`,
        background: `${onFocus || isClicked ? "aliceblue" : ""} `,
        cursor: isClickable ? "pointer" : "",
      }}
    >
      <div className="" style={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <div className="header d-flex justify-content-between" style={{ flex: "1" }}>
          <div className="title">
            <strong>{truncate(digDay.title, 55)}</strong>
          </div>
          <div className="d-flex align-items-center gap-1">
            <div className="state">{Enums.matchDigDayState(digDay.state)}</div>

            {isDetachable && (
              <button
                className="button-with-no-style"
                onClick={() => {
                  setIsClicked(true);
                  handleOnDetachClick();
                }}
              >
                <i className="bx bx-unlink fs-5 " />
              </button>
            )}
          </div>
        </div>
        <div className="description pt-1 text-break" style={{ flex: "2", fontSize: "14px", flexWrap: "wrap" }}>
          {fullSize ? digDay.description : truncate(digDay.description, 113)}
        </div>
        <div className="footer d-flex justify-content-between pt-1 align-items-center" style={{ flex: "1" }}>
          <div className="date-location d-flex justify-content-between">
            <div>
              <i className="bx bx-calendar-alt"></i>&nbsp;
              {convertDateToLocalTime(digDay.date)}
            </div>
            <div className="mx-2">
              <DigDayDurationAndLocation digDay={digDay} />
            </div>
          </div>
          <div className="rating">{digDay.rating ? <ReactStars count={5} size={24} value={digDay.rating} edit={false} /> : ""}</div>
        </div>
      </div>
    </div>
  ) : (
    ""
  );
};
DigDayInfosCard.propTypes = {
  digDay: PropTypes.object,
  fullSize: PropTypes.bool,
  onFocus: PropTypes.bool,
  isClickable: PropTypes.bool,
  isDetachable: PropTypes.bool,
  handleOnDetach: PropTypes.func,
};

export default DigDayInfosCard;
